import React, { useContext, useEffect, useState } from "react";
import AddToProject from "../ExpertDetails/AddToProject";
import expertDefaultImg from "../../images/expert-default.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExpertSimilar({ expert_id }) {
  const [experts, setExperts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { API_URL } = useContext(UrlContext);

  // useEffect(() => {
  //   async function getExperts() {
  //     const url = `${API_URL}similarProfile-for-profile-page`;
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ expertID: expert_id }),
  //     });

  //     const data = await response.json();

  //     if (data.status === "success") {
  //       const promises = data.experts.map(async (expert) => {
  //         const skillResponse = await fetch(
  //           `${API_URL}expert-details-skills/${expert.id}`,
  //           {
  //             method: "GET",
  //             headers: { "Content-Type": "application/json" },
  //           }
  //         );

  //         const skillData = await skillResponse.json();
  //         let { expertSkill } = skillData;
  //         expertSkill = expertSkill.map((item) => item.skillName);
  //         return { ...expert, expertSkill };
  //       });

  //       const allExperts = await Promise.all(promises);
  //       setExperts(allExperts);
  //       setLoading(false);
  //     }
  //   }

  //   getExperts();
  // }, [expert_id]);

  useEffect(() => {
    async function getExperts() {
      setLoading(true);

      try {
        const response = await fetch(
          `${API_URL}similarProfile-for-profile-page`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ expertID: expert_id }),
          }
        );

        const data = await response.json();

        if (data.status === "success") {
          const promises = (data.experts || []).map(async (expert) => {
            const skillResponse = await fetch(
              `${API_URL}expert-details-skills/${expert.id}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            const skillData = await skillResponse.json();

            const expertSkill = (skillData.expertSkill || [])
              .filter(Boolean)
              .map((item) => item.skillName)
              .filter(Boolean);

            return {
              ...expert,
              name: expert.name || "Unnamed Expert",
              summery: expert.summery || "No Summary Available",
              expertSkill,
            };
          });

          const allExperts = await Promise.all(promises);
          setExperts(allExperts);
        } else {
          setExperts([]);
        }
      } catch (error) {
        console.error("Error fetching similar experts:", error);
        setExperts([]);
      } finally {
        setLoading(false);
      }
    }

    getExperts();
  }, [expert_id, API_URL]);

  return (
    <>
      <div
        className="absolute top-0 right-0 w-8 h-8 bg-[#365561] text-white text-xs font-bold flex items-center justify-center"
        style={{
          borderTopRightRadius: "19px",
          borderBottomLeftRadius: "50px",
        }}
      >
        <p className="text-white text-[10px] ml-1 -mt-1">EPH</p>
      </div>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h5 className="text-lg font-semibold text-gray-800">
            Similar Profiles
          </h5>
          {loading && (
            <img src={LoadingIcon} alt="Loading..." className="h-5" />
          )}
        </div>

        {!loading && (
          <div className="space-y-4">
            {experts.map((expert) => (
              <div
                key={expert.id}
                className="flex items-start justify-between gap-4 border-b pb-4 last:border-none"
              >
                <div className="flex gap-3">
                  <a
                    href={`/app/ExpertDetails/${expert.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="w-12 h-12 rounded-full object-cover border"
                      src={expert.profile_picture || expertDefaultImg}
                      alt={expert.name}
                      onError={(e) => (e.target.src = expertDefaultImg)}
                    />
                  </a>
                  <div>
                    <div className="flex justify-between items-center gap-4">
                      <a
                        href={expert.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-800 font-semibold text-sm hover:underline"
                      >
                        {expert.name.length > 18
                          ? expert.name.slice(0, 15) + "..."
                          : expert.name}
                      </a>
                      <span className="text-xs text-gray-500">
                        {Math.trunc(expert.expertRank)}%
                      </span>
                    </div>

                    <div className="relative group text-xs text-gray-600 mt-1">
                      {expert.summery === "No Summary Available"
                        ? expert.summery
                        : expert.summery.length > 100
                        ? `${expert.summery.substring(0, 100)}...`
                        : expert.summery}

                      {expert.summery !== "No Summary Available" && (
                        <div className="absolute z-20 w-60 left-0 top-full mt-1 p-2 bg-white text-gray-800 rounded shadow-lg text-xs hidden group-hover:block">
                          {expert.summery}
                        </div>
                      )}
                    </div>

                    {expert.expertSkill.length > 0 && (
                      <div className="mt-1">
                        <details className="group">
                          <summary className="cursor-pointer list-none">
                            <div className="flex flex-wrap gap-1">
                              {/* When collapsed: show up to 3 skills */}
                              <div className="flex flex-wrap gap-1 group-open:hidden">
                                <div className="similar-skill-div relative">
                                  {expert.expertSkill
                                    .slice(0, 3)
                                    .map((skill, i) => (
                                      <span
                                        key={i}
                                        className="chip similar-skill-span bg-slate-700 text-white text-xs"
                                      >
                                        {skill}
                                      </span>
                                    ))}
                                  {expert.expertSkill.length > 3 && (
                                    <span className="text-xs text-[#365561] font-semibold  w-full">
                                      See all {expert.expertSkill.length}
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* When expanded: show all skills */}
                              <div className="hidden group-open:flex flex-wrap gap-1">
                                <div className="similar-skill-div relative">
                                  {expert.expertSkill.map((skill, i) => (
                                    <span
                                      key={i}
                                      className="chip similar-skill-span bg-slate-700 text-white text-xs"
                                    >
                                      {skill}
                                    </span>
                                  ))}
                                  <span className="text-xs text-[#365561] font-semibold w-full">
                                    See less
                                  </span>
                                </div>
                              </div>
                            </div>
                          </summary>
                        </details>
                      </div>
                    )}

                    <div className="flex gap-1 mt-3">
                      {[
                        expert.logo1,
                        expert.logo2,
                        expert.logo3,
                        expert.logo4,
                        expert.logo5,
                      ]
                        .filter(Boolean)
                        .map((logo, idx) => (
                          <img
                            key={idx}
                            src={
                              logo.includes("/pictures/")
                                ? `https://images.expertpowerhouse.com${logo}`
                                : logo
                            }
                            alt=""
                            className="w-6 h-6 object-contain"
                          />
                        ))}
                    </div>
                  </div>
                </div>

                <div className="shrink-0">
                  <AddToProject expertID={expert.id} btnName={""} />
                </div>
              </div>
            ))}
          </div>
        )}

        {!loading && experts?.length !== 0 && (
          <div className="text-center mt-4">
            <a
              href={`/app/ExpertDetails/${expert_id}/similarprofiles`}
              target="_blank"
              rel="noreferrer"
              className="text-sm text-blue-600 hover:underline"
            >
              See more profiles
            </a>
          </div>
        )}

        <style>
          {`
            .similar-skill-div {
              display: flex;
              flex-wrap: wrap;
            }
            .similar-skill-div .chip {
              border-radius: 11px;
              display: inline-flex;
              line-height: 19px;
              padding: 1px 6px;
            }
          `}
        </style>
      </div>
    </>
  );
}
